import React, { useEffect, useRef } from 'react';
import Carousel from 'react-elastic-carousel';
import { CarouselPagination } from '../../../components/CarouselElements';

const AUTO_PLAY_INTERVAL = 10000;

type FeatureCarouselProps = {
  initialFirstItem?: number;
  enableAutoPlay?: boolean;
  focusOnSelect?: boolean;
  children?: React.ReactNode;
};

interface CarouselState {
  pages: number[];
}

const FeatureCarousel = ({ initialFirstItem, enableAutoPlay, focusOnSelect, children }: FeatureCarouselProps) => {
  const ref = useRef<Carousel & { state: CarouselState; goTo: (index: number) => void }>(null);
  const resetTimeout = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    return () => {
      if (resetTimeout.current) {
        clearTimeout(resetTimeout.current);
      }
    };
  }, []);

  return (
    <Carousel
      className="feature-carousel"
      ref={ref}
      itemsToShow={1}
      itemsToScroll={1}
      itemPadding={[32, 16, 24, 16]}
      initialFirstItem={initialFirstItem}
      showArrows={false}
      enableAutoPlay={enableAutoPlay}
      autoPlaySpeed={AUTO_PLAY_INTERVAL}
      focusOnSelect={focusOnSelect}
      isRTL={false}
      onNextEnd={({ index }) => {
        if (resetTimeout.current) {
          clearTimeout(resetTimeout.current);
        }
        if (ref && 'current' in ref && ref.current && index + 1 === ref.current.state.pages.length) {
          resetTimeout.current = setTimeout(() => {
            if (ref && 'current' in ref && ref.current) {
              ref.current.goTo(0);
            }
          }, AUTO_PLAY_INTERVAL);
        }
      }}
      renderPagination={paginationProps => <CarouselPagination carouselRef={ref} {...paginationProps} />}
    >
      {children}
    </Carousel>
  );
};

FeatureCarousel.displayName = 'FeatureCarousel';

export default FeatureCarousel;
